import React, { memo, useCallback } from 'react';

import { IconButton } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { expandToggleStyles } from '../../Conditions.styles';
import { ConditionsTestIds } from '../../Conditions.testIds';

const ExpandToggleButton = ({
  rowId,
  isExpanded,
  onToggle,
  ariaLabelNoun = '',
  getTestId = ConditionsTestIds.getConditionExpandButtonId,
}) => {
  const onClick = useCallback(() => onToggle(rowId), [onToggle, rowId]);

  const action = isExpanded ? 'Collapse' : 'Expand';

  return (
    <IconButton
      aria-label={ariaLabelNoun ? `${action} ${ariaLabelNoun}` : action}
      data-testid={getTestId(rowId)}
      size="small"
      sx={expandToggleStyles}
      onClick={onClick}
    >
      <ArrowCheckIcon direction={isExpanded ? 'down' : 'right'} />
    </IconButton>
  );
};

ExpandToggleButton.propTypes = {
  rowId: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  ariaLabelNoun: PropTypes.string,
  getTestId: PropTypes.func,
};

export default memo(ExpandToggleButton);
